import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedShape: null,
  selectedCaratRange: null,
  selectedColor: null,
  selectedClarity: null,
  selectedCell: null, // { shape, caratRange }
  selectedCoClCell: null,
  selectedMetric: 'price_change',
  selectedNeedsMetric: '12',
  selectedLocation: '1000global',
};

const marketIntelligenceShapeCaratSlice = createSlice({
  name: 'marketIntelligenceShapeCarat',
  initialState,
  reducers: {
    setSelectedShape: (state, action) => {
      state.selectedShape = action.payload;
    },
    setSelectedCaratRange: (state, action) => {
      state.selectedCaratRange = action.payload;
    },
    setSelectedCell: (state, action) => {
      state.selectedCell = action.payload;
    },
    setSelectedCoClCell: (state, action) => {
      state.selectedCoClCell = action.payload;
    },
    setSelectedColors: (state, action) => {
      state.selectedColor = action.payload;
    },
    setSelectedClarities: (state, action) => {
      state.selectedClarity = action.payload;
    },
    setFilteredPerformanceRedux: (state, action) => {
          state.selectedLocation = action.payload;
    },
    setSelectedMetric: (state, action) => {
      state.selectedMetric = action.payload;
    },
    setSelectedNeedsMetric: (state, action) => {
      state.selectedNeedsMetric = action.payload;
    },
    resetShapeCaratSelection: (state) => {
      return initialState;
    }
  }
});

export const {
  setSelectedShape,
  setSelectedCaratRange,
  setSelectedCell,
  setSelectedCoClCell,
  setSelectedMetric,
  setSelectedColors,
  setSelectedClarities,
  setSelectedNeedsMetric,
  resetShapeCaratSelection,
  setFilteredPerformanceRedux
} = marketIntelligenceShapeCaratSlice.actions;

// Selectors
export const selectMIShapeCaratState = (state) => state.shapeCarat;
export const selectSelectedShape = (state) => state.shapeCarat.selectedShape;
export const selectSelectedCaratRange = (state) => state.shapeCarat.selectedCaratRange;
export const selectSelectedCell = (state) => state.shapeCarat.selectedCell;
export const selectSelectedCoClCell = (state) => state.shapeCarat.selectedCoClCell;
export const selectSelectedColor = (state) => state.shapeCarat.selectedColor;
export const selectSelectedClarity = (state) => state.shapeCarat.selectedClarity;
export const selectSelectedMetric = (state) => state.shapeCarat.selectedMetric;
export const selectSelectedNeedsMetric = (state) => state.shapeCarat.selectedNeedsMetric;
export const selectSelectedLocation = (state) => state.shapeCarat.selectedLocation;

export default marketIntelligenceShapeCaratSlice.reducer;